// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Ca-z"};